var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5C4.5 1.26953 5.48438 0.25 6.75 0.25H12.375V4.75C12.375 5.38281 12.8672 5.875 13.5 5.875H18V16C18 17.2656 16.9805 18.25 15.75 18.25H6.75C5.48438 18.25 4.5 17.2656 4.5 16V12.0625H10.6172L9.24609 13.4336C8.89453 13.7852 8.89453 14.3125 9.24609 14.6289C9.5625 14.9805 10.0898 14.9805 10.4414 14.6289L13.2539 11.8164C13.5703 11.5 13.5703 10.9727 13.2539 10.6211L10.4414 7.80859C10.0898 7.49219 9.5625 7.49219 9.24609 7.80859C8.89453 8.16016 8.89453 8.6875 9.24609 9.00391L10.6172 10.375H4.5V2.5ZM4.5 10.375V12.0625H0.84375C0.351562 12.0625 0 11.7109 0 11.2188C0 10.7617 0.351562 10.375 0.84375 10.375H4.5ZM18 4.75H13.5V0.25L18 4.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.2f0ea2aad0d182c36e5c6d186574b199.svg";
export { ForwardRef as ReactComponent };